import { createSchema, Yup } from '@src/corelib/validation';


/**
 * Storefront form (M13). The single `slug` field is an optional string client-
 * side — validation (format, uniqueness, reserved names, required-when-enabling)
 * is server-driven, with 400 field errors mapped back onto the input via the
 * Form's `showServerErrors`. The `storefront_enabled` toggle is controlled
 * outside the form and merged into the PATCH payload at submit.
 */

const STOREFRONT_BASE_DOMAIN = 'autoorbit.com';


const storefrontSchema = createSchema({ slug: Yup.string() });


/** Map a seller record onto the form's string-valued shape. */
function storefrontDefaults(seller) {
  return { slug: seller?.slug || '' };
}


/** Build the public storefront URL preview for a slug (placeholder when empty). */
function storefrontUrl(slug) {
  const value = (slug || '').trim().toLowerCase();
  return `https://${value || 'your-slug'}.${STOREFRONT_BASE_DOMAIN}`;
}


export {
  STOREFRONT_BASE_DOMAIN,
  storefrontDefaults,
  storefrontSchema,
  storefrontUrl,
};
